var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.logoSrc)?_c('div',{staticClass:"logo",style:({ height: `${_vm.size}px`, width: `${_vm.size}px` })},[_c('img',{attrs:{"height":_vm.size,"width":_vm.size,"src":_vm.logoSrc}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }